import { setup, tw } from 'twind';
import presetTailwind from '@twind/preset-tailwind';

type TwindSetupConfig = Parameters<typeof setup>[0] & {
  presets?: Array<ReturnType<typeof presetTailwind>>;
};

const globalTwind = globalThis as typeof globalThis & {
  __twindInitialized?: boolean;
};

if (!globalTwind.__twindInitialized) {
  const config: TwindSetupConfig = {
    presets: [
      presetTailwind({
        // IMPORTANTE: Desabilitar preflight para evitar conflitos com CSS do MobileDialer
        // e outros estilos do host. Preflight reseta margin, padding, box-sizing etc.
        disablePreflight: true,
      }),
    ],
    theme: {
      extend: {
        colors: {
          primary: '#1f7aed',
          primaryDark: '#1557a5',
          accent: '#1dd1a1',
        },
      },
    },
  };

  setup(config);

  globalTwind.__twindInitialized = true;
}

export { tw };
